import { MessageSquare, Briefcase, TrendingUp, Users, CalendarClock, Target } from "lucide-react";
import Reveal from "@/components/landing/Reveal";

const benefits = [
  {
    icon: Briefcase,
    title: "Enfoque en empleabilidad",
    text: "Nuestra oferta académica está dirigida a la empleabilidad: aprendes el inglés que el mercado laboral realmente valora.",
    highlight: true,
  },
  {
    icon: MessageSquare,
    title: "Habilidades comunicativas",
    text: "Fortalece tu capacidad de expresarte y comprender el inglés en situaciones reales.",
  },
  {
    icon: TrendingUp,
    title: "Desarrollo personal y profesional",
    text: "Impulsa tu crecimiento con un idioma que abre puertas en estudio y trabajo.",
  },
  {
    icon: Target,
    title: "Aprendizaje progresivo",
    text: "Avanza paso a paso por niveles, desde A1 hasta B2, según el Marco Común Europeo.",
  },
  {
    icon: Users,
    title: "Acompañamiento constante",
    text: "Recibe acompañamiento docente en todo tu proceso de aprendizaje.",
  },
  {
    icon: CalendarClock,
    title: "Clases y horarios",
    text: "Clases presenciales en nuestra sede, con horarios que se adaptan a ti.",
  },
];

export default function Benefits() {
  return (
    <section id="beneficios" className="py-20 lg:py-32 bg-white" data-testid="benefits-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">
            ¿Por qué estudiar inglés en el PIO?
          </span>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 max-w-3xl">
            El inglés te abre más posibilidades
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed max-w-2xl">
            Mejora tu perfil profesional, comunícate con mayor confianza, prepárate para nuevos
            retos y conecta con el mundo.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="benefits-grid">
          {benefits.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.06}>
              <div
                data-testid={`benefit-card-${i + 1}`}
                className={`h-full rounded-2xl border p-7 transition-transform hover:-translate-y-1 ${
                  b.highlight
                    ? "border-blue-600 bg-blue-600 text-white shadow-lg shadow-blue-900/10"
                    : "border-slate-200 bg-slate-50 hover:shadow-lg hover:shadow-blue-900/5"
                }`}
              >
                <span
                  className={`w-11 h-11 rounded-xl flex items-center justify-center ${
                    b.highlight ? "bg-white/15 text-white" : "bg-blue-600/10 text-blue-600"
                  }`}
                >
                  <b.icon className="w-5 h-5" />
                </span>
                <h3 className={`mt-5 font-heading text-lg font-semibold ${b.highlight ? "text-white" : "text-slate-900"}`}>
                  {b.title}
                </h3>
                <p className={`mt-2 text-sm leading-relaxed ${b.highlight ? "text-blue-100" : "text-slate-600"}`}>
                  {b.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
